import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CompanyDetailsComponent } from "app/company-details/company-details.component";
import { SubProductsComponent } from "app/company-details/sub-products/sub-products.component";

const routes: Routes = [
  { path: '' , component: CompanyDetailsComponent},
  { path: 'group-details/:id', component: SubProductsComponent}];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CompanyDetailsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/company-details/company-details-routing.module.ts